import React from 'react';
import { AdminPageContainer } from '../../../components/admin/sharedStyles';
import PageHeader from '../../../components/PageHeader';
import ConfigSubMenu from '../../../components/admin/ConfigSubMenu';
import PdfTemplateDesigner from '../../../components/admin/pdf-template/PdfTemplateDesigner';

const InvoicePdfTemplate = () => {
    return (
        <AdminPageContainer>
            <PageHeader
                title="Invoice PDF Template"
                subtitle="Upload a PDF template and define where invoice data fields are placed"
            />

            <ConfigSubMenu />

            <PdfTemplateDesigner />
        </AdminPageContainer>
    );
};

export default InvoicePdfTemplate;
